const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1',
  APP_NAME: 'Membox',
  APP_VERSION: '1.0.0'
};

export default config;